/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otaupdatemessage2Inputs */



/**
* | output |
* | --- |
* | "Luni just got better. Install now?" |
*
* @param {Otaupdatemessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const otaupdatemessage2 = /** @type {((inputs?: Otaupdatemessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otaupdatemessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Luni just got better. Install now?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Luni ahora es aún mejor. ¿Instalar ahora?")
	return /** @type {LocalizedString} */ ("Луни стал ещё лучше. Установить сейчас?")
});
export { otaupdatemessage2 as "otaUpdateMessage" }